<template>
  <v-app>
    <NavBar />
    <v-main>
      <v-parallax :src="require('./assets/complex_tech_background.svg')" class="fill-height">
        <router-view fluid class="pa-0 fill-height" ref="routerView" :isLoggedIn="isLoggedIn"/>
      </v-parallax>
    </v-main>
    <AppFooter />
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="5000" content-class="text-center">{{ snackbar.message }}</v-snackbar>
  </v-app>
</template>

<script setup>
import { setAuthToken } from './axios';
import { useUiStore }    from '@/stores/ui';
import { useUserStore } from '@/stores/user';
import { computed } from 'vue';
import NavBar from './components/NavBar.vue';
import AppFooter from './components/AppFooter.vue';

const uiStore     = useUiStore();
const userStore   = useUserStore();

const snackbar = computed(() => uiStore.snackbar);

const isLoggedIn = computed(() => userStore.isLoggedIn);

// Si al montar ya hay token, configúralo
if (userStore.token) {
  setAuthToken(userStore.token);
  userStore.fetchUserDetails();
}

</script>
